<template>
  <div style="margin: 18px 0 0 0;  height: 260px;">
    <a-spin :spinning="spinning">
      <bar-chart-usage-top
        v-if="chartData.length"
        unit="分"
        :chart-data="chartData"
        :bar-color="barColor"
        :bg-color="bgColor"
        :height="260"
        chart-id="virtual-machine-storage-usage-chart"
      ></bar-chart-usage-top>
      <div v-else style="height: 260px; position: relative; overflow: hidden;">
        <empty-component
          :imgUrl="require('@/assets/images/info_empty.png')"
          :body-style="{
            height: '120px',
            marginTop: '48px'
          }"
          :description-style="{
            marginTop: '-8px',
            marginRight: '8px'
          }"
          description="暂无数据"
        ></empty-component>
      </div>
    </a-spin>
  </div>
</template>

<script>
import BarChartUsageTop from '@/components/top/BarChartUsageTop'
import {
  getServiceHealth
} from '@/api/service'

export default {
  name: 'HealthChart',
  components: {
    EmptyComponent: () => import('@/components/EmptyComponent.vue'),
    BarChartUsageTop
  },
  props: {
    serviceId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      chartData: [],
      spinning: false,
      barColor: this.barColorFunc,
      bgColor: this.bgColorFunc
    }
  },
  mounted () {
    this.fetch()
  },
  methods: {
    fetch () {
      this.spinning = true
      getServiceHealth(this.serviceId).then(res => {
        if (res.data.statistic) {
          this.chartData = res.data.statistic.map(item => {
            return {
              name: item.name,
              value: item.score
            }
          }).sort((a, b) => a.value - b.value)
        }
      }).finally(() => { this.spinning = false })
    },
    bgColorFunc (val) {
      if (val >= 80) return '#43B94D20'
      else if (val >= 60) return '#fa8c1620'
      else return '#f5222d20'
    },
    barColorFunc (val) {
      if (val >= 80) return 'l(90) 0:#97fc9f 1:#43B94D'
      else if (val >= 60) return 'l(90) 0:#ffdd9a 1:#fa8c16'
      else return 'l(90) 0:#ffa3a8 1:#f5222d'
    }
  }
}
</script>
